import {
	ACTIVE_ADD_PEOPLE_MODAL_FOR_PROJECT,
	CLEAR_ANONYMISE_PROFILES,
	CLEAR_SIMILAR_CANDIDATES_RESULTS,
	FLAG_CANDIDATE,
	GET_CANDIDATES_BY_FILTER_DONE,
	GET_CANDIDATES_BY_FILTER_INIT,
	GET_CANDIDATES_DONE,
	GET_CANDIDATES_FAIL,
	GET_CANDIDATES_INIT,
	GET_SIMILAR_CANDIDATES_DONE,
	GET_SIMILAR_CANDIDATES_FAIL,
	GET_SIMILAR_CANDIDATES_INIT,
	GET_SINGLE_CANDIDATE_DONE,
	GET_SINGLE_CANDIDATE_FAIL,
	GET_SINGLE_CANDIDATE_INIT,
	IMPORT_LINKEDIN_PROFILE_IN_PROGRESS,
	RESET_FILTERED_CANDIDATES,
	SEARCH_LINKEDIN_PROFILE_IN_PROGRESS_FOR_CURRENT_IMPORT,
	SET_ANONYMISE_PROFILES,
	SET_CANDIDATES_PAGINATION_INFO,
	SET_IMPORT_LINKEDIN_PROFILE_INFO,
	SET_SELECTED_CANDIDATES_DONE,
	SET_SELECTED_CANDIDATES_INIT,
	SET_SIMILAR_CANDIDATES_WITH_PAGINATION,
	TOGGLE_ANONYMISE_PROFILE_TURN_ON,
} from "store/mapXActionTypes";

export function setSelectedCandidatesDone(data) {
	return {type: SET_SELECTED_CANDIDATES_DONE, payload: data};
}

export function setSelectedCandidatesInit() {
	return {type: SET_SELECTED_CANDIDATES_INIT, payload: true};
}

export function getCandidatesInit() {
	return {type: GET_CANDIDATES_INIT};
}

export function getCandidatesDone(data) {
	return {type: GET_CANDIDATES_DONE, payload: data};
}

export function getCandidatesFail(error) {
	return {type: GET_CANDIDATES_FAIL, payload: error};
}

export function getCandidatesByFilterInit() {
	return {type: GET_CANDIDATES_BY_FILTER_INIT};
}

export function getCandidatesByFilterDone(data) {
	return {type: GET_CANDIDATES_BY_FILTER_DONE, payload: data};
}

export function setCandidatesPaginationInfo(data) {
	return {type: SET_CANDIDATES_PAGINATION_INFO, payload: data};
}

export function getCandidatesByFilterFail(error) {
	return {type: GET_CANDIDATES_FAIL, payload: error};
}

export function getSimilarCandidatesInit() {
	return {type: GET_SIMILAR_CANDIDATES_INIT};
}

export function getSimilarCandidatesDone(payload) {
	return {type: GET_SIMILAR_CANDIDATES_DONE, payload};
}

export function getSimilarCandidatesFail(error) {
	return {type: GET_SIMILAR_CANDIDATES_FAIL, payload: error};
}

export function clearSimilarCandidatesResults() {
	return {type: CLEAR_SIMILAR_CANDIDATES_RESULTS};
}

export function setSimilarProfilesWithPagination(payload) {
	return {type: SET_SIMILAR_CANDIDATES_WITH_PAGINATION, payload};
}

export function getSingleCandidateInit() {
	return {type: GET_SINGLE_CANDIDATE_INIT};
}

export function getSingleCandidateDone(data) {
	return {type: GET_SINGLE_CANDIDATE_DONE, payload: data};
}

export function getSingleCandidateFail(error) {
	return {type: GET_SINGLE_CANDIDATE_FAIL, payload: error};
}

export function resetFilteredCandidates() {
	return {type: RESET_FILTERED_CANDIDATES};
}

export function flagCandidate(payload) {
	return {type: FLAG_CANDIDATE, payload};
}

// IMPORTING LINKEDIN PROFILE

export function importLinkedInCandidateInProgress(payload) {
	return {type: IMPORT_LINKEDIN_PROFILE_IN_PROGRESS, payload};
}

export function setImportLinkedInProfileInfo(payload) {
	return {type: SET_IMPORT_LINKEDIN_PROFILE_INFO, payload};
}

/**
 ** @param payload: {projectId: true|false}
 */

export function setSearchProgressCandidateByLinkedInForProject(payload) {
	return {type: SEARCH_LINKEDIN_PROFILE_IN_PROGRESS_FOR_CURRENT_IMPORT, payload};
}

export function activeAddPeopleModalForProject(payload) {
	return {type: ACTIVE_ADD_PEOPLE_MODAL_FOR_PROJECT, payload};
}

export function toggleAnonymiseProfileTurnOn(payload) {
	return {type: TOGGLE_ANONYMISE_PROFILE_TURN_ON, payload};
}

export function setAnonymiseProfiles(payload) {
	return {type: SET_ANONYMISE_PROFILES, payload};
}

export function clearAnonymiseProfiles() {
	return {type: CLEAR_ANONYMISE_PROFILES};
}
